<template>
    <div>
        <MenuStorage/>
        <Expire_stock/>
    </div>
</template>

<script>
    import MenuStorage from "@/components/admin/stock/menustorage/MenuStorage.vue";
    import Expire_stock from "@/components/admin/stock/storage_expire/Expire_stock.vue";
    export default {
        name: "ExpireStorage",
        components: {
            Expire_stock,
            MenuStorage
        }
    }
</script>

<style scoped>

</style>
